// @mui
import {
	ListItemText,
	ListItemAvatar,
	ListItem,
} from "@mui/material";
import Iconify from "../iconify";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import React, { useState } from "react";
// ----------------------------------------------------------------------

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};
export default function OptionsOrderingTable(props) {
	const [state, setState] = useState({ options: props.options });
	function onDragEnd(result) {
		if (!result.destination) {
			return;
		}

		if (result.destination.index === result.source.index) {
			return;
		}

		const options = reorder(
			state.options,
			result.source.index,
			result.destination.index
		).map((option, index) => {
			option.option_order = index;
			return option;
		});

		props.reorderHandler(options);
		setState({ options });
	}
	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable droppableId="droppable">
				{(provided, snapshot) => (
					<div {...provided.droppableProps} ref={provided.innerRef}>
						{state.options.map((item, index) => (
							<Draggable
								key={item.option_id}
								draggableId={item.option_id.toString()}
								index={index}
							>
								{(provided, snapshot) => (
									<ListItem
										ref={provided.innerRef}
										{...provided.draggableProps}
										{...provided.dragHandleProps}
									>
										<ListItemAvatar>
											<Iconify icon="eva:flip-outline" />
										</ListItemAvatar>
										<ListItemText primary={item.title_en} secondary="" />
									</ListItem>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
}
